var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNivel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.391,
    height: 10.623,
    viewBox: "0 0 14.391 10.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.391,
    height: 10.623,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53",
    "data-name": "Trazado 53",
    d: "M89,69.051h14.391V84.674H89Zm0,0",
    transform: "translate(0)",
    fill: "#5abf3f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_desplazamiento_4",
    "data-name": "Grupo de desplazamiento 4",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disen\\u0303o_sin_ti\\u0301tulo-2",
    "data-name": "Disen\\u0303o sin ti\\u0301tulo-2",
    transform: "translate(-89 -69.051)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52",
    "data-name": "Trazado 52",
    d: "M89.691,71.069h4.746a2.063,2.063,0,0,1,4.034,0h4.746a.432.432,0,0,1,0,.863H98.472a2.063,2.063,0,0,1-4.034,0H89.691A.432.432,0,0,1,89.691,71.069Zm13.527,5.754H101.35a2.063,2.063,0,0,0-4.035,0H89.691a.432.432,0,0,0,0,.863h7.624a2.063,2.063,0,0,0,4.035,0h1.868A.432.432,0,0,0,103.219,76.823Z",
    transform: "translate(-0.254 -0.378)",
    fill: "#5abf3f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivel);
export default __webpack_public_path__ + "static/media/nivel.f8aa62a1f0dcf5b30ce2ba5b02147eed.svg";
export { ForwardRef as ReactComponent };